import { render, staticRenderFns } from "./HCP_list.vue?vue&type=template&id=013bf4b4&scoped=true"
import script from "./HCP_list.vue?vue&type=script&lang=js"
export * from "./HCP_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013bf4b4",
  null
  
)

export default component.exports